<div class="container centered-container">
  <div class="filter-container">
    <p-dropdown [(ngModel)]="selectedVariant" [options]="variantOptions" (onChange)="applyFilter()"
                placeholder="Any Variant" [showClear]="true" (onShow)="clearVariantFilter()"
                [filter]="true" filterBy="label" optionLabel="label"
                styleClass="p-dropdown-width"
                [showTransitionOptions]="'100ms'" [hideTransitionOptions]="'50ms'"
    >
      <ng-template let-option pTemplate="item">
        <span>{{option.label}}</span>
      </ng-template>
    </p-dropdown>

    <!-- Type Filter -->
    <p-dropdown [(ngModel)]="selectedType" [options]="typeOptions" (onChange)="applyFilter()"
                placeholder="Any Type" [showClear]="true" (onShow)="clearTypeFilter()"
                [filter]="true" filterBy="label" optionLabel="label">
      <ng-template let-option pTemplate="item">
        <span>{{option.label}}</span>
      </ng-template>
    </p-dropdown>

    <!-- Country Filter -->
    <p-dropdown [(ngModel)]="selectedCountry" [options]="countryOptions" (onChange)="applyFilter()"
                placeholder="Any Country" [showClear]="true" (onShow)="clearCountryFilter()"
                [filter]="true" filterBy="label" optionLabel="label">
      <ng-template let-option pTemplate="item">
        <span>{{option.label}}</span>
      </ng-template>
    </p-dropdown>

<!--    <button mat-raised-button color="primary" (click)="clearFilters()">הצג הכל</button>-->
    <button mat-raised-button color="primary" (click)="clearFilters()" [matTooltip]="'EU_STANDARD.CLEAR_FILTER' | translate">
      <fa-icon [icon]="faFilter"></fa-icon>
    </button>
  </div>

  <div class="table-container" *ngIf="!isSmallScreen">
    <table mat-table [dataSource]="filteredData" class="mat-elevation-z8"
           matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
      <!-- Define Columns -->
      <!-- ID Column -->
      <ng-container matColumnDef="Id" >
        <th mat-header-cell *matHeaderCellDef> ID</th>
        <td mat-cell *matCellDef="let element"> {{element.Id}} </td>
      </ng-container>

      <!-- ManufacturerName Column -->
      <ng-container matColumnDef="ManufacturerName">
        <th mat-header-cell *matHeaderCellDef  class="manufacturer-column"> {{ 'CAR_MARKET.MANUFACTURER' | translate }}</th>
        <td mat-cell *matCellDef="let element" class="manufacturer-column"> {{element.ManufacturerName}} </td>
      </ng-container>

      <!-- ManufactureCountry Column -->
      <ng-container matColumnDef="ManufactureCountry">
        <th mat-header-cell *matHeaderCellDef class="manufacturer-column"> {{ 'EU_STANDARD.COUNTRY_OF_MANUFACTURE' | translate }}</th>
        <td mat-cell *matCellDef="let element" class="manufacturer-column"> {{element.ManufactureCountry}} </td>
      </ng-container>

      <!-- StandardizationType Column -->
      <ng-container matColumnDef="StandardizationType">
        <th mat-header-cell *matHeaderCellDef class="narrow-column"> {{ 'EU_STANDARD.STANDARDIZATION_TYPE' | translate }}</th>
        <td mat-cell *matCellDef="let element" class="narrow-column"> {{element.StandardizationType}} </td>
      </ng-container>

      <!-- Type Column -->
      <ng-container matColumnDef="Type">
        <th mat-header-cell *matHeaderCellDef class="manufacturer-column"> Type</th>
        <td mat-cell *matCellDef="let element" class="manufacturer-column"> {{element.Type}} </td>
      </ng-container>

      <!-- Variant Column -->
      <ng-container matColumnDef="Variant">
        <th mat-header-cell *matHeaderCellDef class="manufacturer-column"> Variant</th>
        <td mat-cell *matCellDef="let element" class="manufacturer-column"> {{element.Variant}} </td>
      </ng-container>

      <!-- More columns can be defined similarly -->

      <ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </ng-container>

    </table>
  </div>
  <div class="mobile-view" *ngIf="isSmallScreen">
    <div *ngFor="let row of filteredData" class="mobile-row">
      <!-- Render row data in a stacked layout -->
      <div class="mobile-row-cell">
        <strong>{{ 'CAR_MARKET.MANUFACTURER' | translate }}:</strong> {{ row.ManufacturerName }}
      </div>
      <div>
        <strong>{{ 'EU_STANDARD.COUNTRY_OF_MANUFACTURE' | translate }}:</strong> {{ row.ManufactureCountry }}
      </div>
      <div>
        <strong>{{ 'EU_STANDARD.STANDARDIZATION_TYPE' | translate }}:</strong> {{ row.StandardizationType }}
      </div>
      <div>
        <strong>Type:</strong> {{ row.Type }}
      </div>
      <div>
        <strong>Variant:</strong> {{ row.Variant }}
      </div>
    </div>
  </div>
</div>
